import React, { useState } from 'react';
import {
  RAID_LOGO_SPLATTER_SRC,
  RAID_LOGO_SUMMER_SRC,
  RAID_LOGO_WORDMARK_SRC,
} from './raidLogoAssets';
import { useRaidFvBootContext } from './RaidFvBootGate';
import styles from './RaidLogoAnimation.module.css';

export default function RaidLogoAnimation({
  ariaLabel = 'RAID 2026 logo animation',
}) {
  const { booting } = useRaidFvBootContext();

  // SUMMER テキストはアニメ完了後も filter(blur) が残ると
  // iOS Safari で SVG が等倍ラスタライズされてにじむため、
  // 完了時に filter / transform を確定状態へ切り替えてレイヤーを解放する。
  const [summerSettled, setSummerSettled] = useState(false);

  return (
    <section
      className={`${styles.stage} ${booting ? styles.frozen : ''}`}
      aria-label={ariaLabel}
    >
      <div className={styles.logoStack}>
        <span
          className={`${styles.layer} ${styles.impactGlow}`}
          aria-hidden="true"
        />
        <span
          className={`${styles.layer} ${styles.impactBall}`}
          aria-hidden="true"
        />
        <img
          src={RAID_LOGO_SPLATTER_SRC}
          alt=""
          className={`${styles.layer} ${styles.splatter}`}
          aria-hidden="true"
        />
        <span className={`${styles.layer} ${styles.wordmarkReveal}`}>
          <img
            src={RAID_LOGO_WORDMARK_SRC}
            alt="RAID"
            className={styles.wordmark}
          />
        </span>
        <span
          className={`${styles.summerReveal} ${
            summerSettled ? styles.summerSettled : ''
          }`}
          onAnimationEnd={() => setSummerSettled(true)}
        >
          <img
            src={RAID_LOGO_SUMMER_SRC}
            alt="SUMMER INTERNSHIP 2026"
            className={styles.summerText}
          />
        </span>
      </div>
    </section>
  );
}
